module.exports = __webpack_public_path__ + "static/media/acmg-login.560ea9ab.png";